import React from "react";
import "./News.css";
import pic from "../../assets/Group 49.png";
const News = () => (
  <div className='news__container section__padding' id='news'>
    <img src={pic} />
  </div>
);

export default News;
